module.exports = __webpack_public_path__ + "img/firefox_logo.da701f97.svg";